module.exports = __webpack_public_path__ + "static/urbanhus-recording-7ad05307639688244626f6f6348779e1.mp4";